// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.skills {
  box-sizing: border-box;
  display: block;
  padding: 1px 16px 16px 16px;
  margin: 1em 0;
  background: #F7F9FC;
  border-radius: 6px;
  position: relative;
  color: #1E2532;
}


.skill__item {
  display: inline-block;
  padding: 6px 10px;
  border: 1px solid #e7eaf4;
  border-radius: 3px;
  margin: 0 2px 2px 2px;
  font-weight: bold;
}

.skills-container {
  display: none;
  width: 100%;
  height: 100%;
  max-height: 232px;
  padding: 8px;
  border-top: 1px solid #e6ebf4;
  overflow-y: auto;

  &.is-visible {
    display: block;
  }
}

.selected-skills .skills_selected_skill {
  display: inline-block;
  padding: 0 6px;
  border-radius: 10px;
  background-color: #f1f1f1;
  margin: 4px 2px;
}

.selected-skills .closebtn {
  padding-left: 10px;
  color: #888;
  font-weight: bold;
  float: right;
  font-size: 20px;
  cursor: pointer;
}

.selected-skills .closebtn:hover {
  color: #000;
}

.skills h4 {
  font-family: sans-serif;
  font-size: 12px;
  line-height: 16px;
  top: 20px;
  left: 16px;
  right: 16px;
  padding-bottom: 20px;
  padding-top: 4px;
  color: #656e83;
  border-bottom: 1px solid #e7eaf4;
}
.link-modal__loading svg{
    margin: auto;
    width: 100px;
    height: 100px;

}
`, "",{"version":3,"sources":["webpack://./src/plugins/skills/styles.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;;AAEjB","sourcesContent":["\n.skills {\n  box-sizing: border-box;\n  display: block;\n  padding: 1px 16px 16px 16px;\n  margin: 1em 0;\n  background: #F7F9FC;\n  border-radius: 6px;\n  position: relative;\n  color: #1E2532;\n}\n\n\n.skill__item {\n  display: inline-block;\n  padding: 6px 10px;\n  border: 1px solid #e7eaf4;\n  border-radius: 3px;\n  margin: 0 2px 2px 2px;\n  font-weight: bold;\n}\n\n.skills-container {\n  display: none;\n  width: 100%;\n  height: 100%;\n  max-height: 232px;\n  padding: 8px;\n  border-top: 1px solid #e6ebf4;\n  overflow-y: auto;\n\n  &.is-visible {\n    display: block;\n  }\n}\n\n.selected-skills .skills_selected_skill {\n  display: inline-block;\n  padding: 0 6px;\n  border-radius: 10px;\n  background-color: #f1f1f1;\n  margin: 4px 2px;\n}\n\n.selected-skills .closebtn {\n  padding-left: 10px;\n  color: #888;\n  font-weight: bold;\n  float: right;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.selected-skills .closebtn:hover {\n  color: #000;\n}\n\n.skills h4 {\n  font-family: sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  top: 20px;\n  left: 16px;\n  right: 16px;\n  padding-bottom: 20px;\n  padding-top: 4px;\n  color: #656e83;\n  border-bottom: 1px solid #e7eaf4;\n}\n.link-modal__loading svg{\n    margin: auto;\n    width: 100px;\n    height: 100px;\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
